<template>
  <div class="Side">
    <div class="sidenav">
      <img style="width: 120px;" src="@/assets/images/logo.png">
      <ul>
        <li class="flag-route" v-for="(k, f) in sidenav" :key="f"  > 
          <router-link 
            v-bind:class="{'active-class': k.r == f, 'active-class':  k.r == flag}" 
            :to="k.ruta">
            <button v-on:click="active(k.r)" class="btn o-r">
              <img :src="getImgUrl(k.icon)" alt="">
              <span>{{k.name}}</span>
            </button>
          </router-link>
        </li>
      </ul>
    </div>
  </div> 
</template>

<script>
export default {
  name: 'Side',
  
  data () {
    return {
      sidenav: [
        { icon: 'user_icon', name: 'Usuarios', ruta: '/users', r: 1},
        { icon: 'res_icon', name: 'Reservaciones', ruta: '/reservation', r: 2},
        { icon: 'est_icon', name: 'Estilistas', ruta: '/stylist', r: 3},
        { icon: 'ser_icon', name: 'Servicios', ruta: '/services', r: 4},
        { icon: 'promo_icon', name: 'Promocodes', ruta: '/codes', r: 5},
        { icon: 'push_icon', name: 'Push', ruta: '/push', r: 6},
        { icon: 'rep_icon', name: 'Reporte', ruta: '/reports', r: 7},
        { icon: 'res_icon', name: 'Bloquear horarios', ruta: '/bloqued', r: 8},
        
      ],
      activeInit: '',
      flag: 0
    }
  },

  beforeMount() {
    if(this.$route.path == '/dashboard'){
      this.flag = 1
    }
  },
  
  methods: {
    getImgUrl(icon){
      return require('../assets/images/'+icon+ ".svg")
    },
    active(index){
      this.flag = 0
      this.selected = index + 1
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .sidenav {
    height: 100%;
    width: 277px;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #111;
    overflow-x: hidden;
    padding-top: 100px;
    text-align: center;
  }

  .sidenav ul {
    list-style: none;
    text-align: left;
  }

  .sidenav button {
    padding: 26px 8px 6px 16px;
    text-decoration: none;
    font-size: 14px;
    color: #fff;
    display: block;
    font-weight: 800;
    letter-spacing: 2px;
  }

  .sidenav a{
    color: #fff;
  }
  
  .sidenav a:hover{
    color: #85EEB3;
    text-decoration: none;
  }

  .sidenav ul li a:hover {
    color: #85EEB3;
    filter: invert(87%) sepia(17%) saturate(1044%) hue-rotate(81deg) brightness(705%) contrast(87%);
  }

  .o-r img{
    width: 18px;
    margin-right: 10px;
  }

  .active-class{
    color: #85EEB3;
    filter: invert(87%) sepia(17%) saturate(1044%) hue-rotate(81deg) brightness(705%) contrast(87%);
    text-decoration: none;
  }


.router-link-active{
  color: #85EEB3;
  filter: invert(87%) sepia(17%) saturate(1044%) hue-rotate(81deg) brightness(705%) contrast(87%);
}
</style>
